module.exports = __webpack_public_path__ + "img/dot-icon.cd3897da.svg";